var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 90,
    viewBox: "0 0 114 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.609 0.945312C95.8672 1.53125 74.5781 3.67969 61.4922 11.6875C60.5156 12.2734 59.9297 13.25 59.9297 14.2266V85.3203C59.9297 87.6641 62.4688 89.0312 64.6172 88.0547C78.0938 81.2188 97.625 79.2656 107.195 78.875C110.516 78.6797 113.055 75.9453 113.055 72.8203V6.80469C113.25 3.48438 110.125 0.75 106.609 0.945312ZM52.3125 11.6875C39.2266 3.67969 17.9375 1.53125 7.19531 0.945312C3.67969 0.75 0.75 3.48438 0.75 6.80469V72.8203C0.75 75.9453 3.28906 78.6797 6.60938 78.875C16.1797 79.2656 35.7109 81.2188 49.1875 88.0547C51.3359 89.0312 53.875 87.6641 53.875 85.3203V14.2266C53.875 13.25 53.2891 12.2734 52.3125 11.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.cb18afb1d1b27d7c6ea1f3361d923c5f.svg";
export { ForwardRef as ReactComponent };